/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { Asset } from './Asset';

enum SubstanceMaterialFormats {
  SBSAR = 'sbsar',
  SBS = 'sbs',
  MDL = 'mdl'
}

const SubstanceMaterialDefaultFormat = SubstanceMaterialFormats.SBSAR;

class SubstanceMaterial extends Asset {
  isMaterial: boolean;

  constructor(rawAsset: Object) {
    super(rawAsset);
    this.isMaterial = true;
    this.formats = [
      SubstanceMaterialFormats.SBSAR,
      SubstanceMaterialFormats.SBS,
      SubstanceMaterialFormats.MDL
    ];
    this.defaultFormat = SubstanceMaterialDefaultFormat;
  }
}

export {
  SubstanceMaterial,
  SubstanceMaterialFormats,
  SubstanceMaterialDefaultFormat
};
